module.exports = __webpack_public_path__ + "static/media/puntosFondo.d6147f5c.png";